import React, { useEffect } from 'react';
import toastError from "../../errors/toastError";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import { Button, Divider, } from "@mui/material";

const LocationPreview = ({ image, link, description }) => {
    useEffect(() => {}, [image, link, description]);

    const handleLocation = async() => {
        try {
            if (!link || !link.startsWith("https://")) return;
            window.open(link, "_blank", "noopener,noreferrer");
        } catch (err) {
            toastError(err);
        }
    }

    return (
		<>
			<div style={{
				minWidth: "250px",
			}}>
				<div>
					<div style={{ float: "left" }}>
						<img src={image} onClick={handleLocation} style={{ width: "100px" }} />
					</div>
					{ description && (
					<div style={{ display: "flex", flexWrap: "wrap" }}>
						<Typography style={{ marginTop: "12px", marginLeft: "15px", marginRight: "15px", float: "left", whiteSpace: "pre-wrap" }} variant="subtitle1" color="primary" gutterBottom>
							{description.replace('\\n', '\n')}
						</Typography>
					</div>
					)}
					<div style={{ display: "block", content: "", clear: "both" }}></div>
					<div>
						<Divider />
						<Button
							fullWidth
							color="primary"
							onClick={handleLocation}
							disabled={!link}
						>Visualizar</Button>
					</div>
				</div>
			</div>
		</>
	);

};

export default LocationPreview;